import Vue from 'vue'
import App from './App.vue'
import router from './routers'
import store from './store/login'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'
import dayjs from "dayjs";

Vue.use(ElementUI)
Vue.prototype.$dayjs = dayjs;

// Handle chunk loading errors (happens after deployment with new builds)
// Auto-reload the page to get fresh chunks
router.onError((error) => {
  const pattern = /Loading (CSS )?chunk .+ failed/gi
  const isChunkLoadFailed = pattern.test(error.message)
  if (isChunkLoadFailed) {
    console.warn('Chunk load failed, reloading page to get fresh assets...')
    window.location.reload()
  }
})

// Remove any global component registrations for Head, Quiz, or Steps

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')